import Divider from 'antd/es/divider';

export default Divider;
